export default function initScopeFactory(data, dictonary, ecFormBuilderController) {
  return function initScope(scope, xPath) {
    console.warn('DEPRECATED - si vez este mensaje, por favor avisa a @odeniel', xPath);
    // añade en el scope los datos:
    // initChildScope(scope, 'CAB.LIN')
    // scope.model === scope.LIN === scope.CAB.LIN
    // scope.nameRegister = 'LIN'
    //

    const parent = xPath.split('.').slice(-2)[0];
    const model = xPath.split('.').slice(-1)[0];
    //
    // copiamos el objeto "CAB" en el scope
    Object.assign(scope, data);
    // añadimos el nombre del registro ej. "NAD"
    scope.nameRegister = parent;
    // scope.data = getParent();
    // scope[model] = scope.data; el parent ya viene en el scope
    scope.data = scope[parent]; //
    scope.value = (scope[parent] || {})[model];
    scope.ecFormBuilderController = ecFormBuilderController;
  };
}
